document.addEventListener("DOMContentLoaded", () => {
    const namespace = document.querySelector('body').getAttribute('namespace')

    document.querySelectorAll(".image-slider.export").forEach(slider => {
        const localizedText = {
            exportPdf: document.querySelector('meta[name="localized-export-pdf"]')?.getAttribute("content") || "Export PDF",
            exporting: document.querySelector('meta[name="localized-exporting"]')?.getAttribute("content") || "Exporting...",
            exportError: document.querySelector('meta[name="localized-export-error"]')?.getAttribute("content") || "Error exporting PDF"
        }

        const getImageType = () => {
            if (slider.classList.contains("pre_repair")) return "pre_repair"
            if (slider.classList.contains("post_repair")) return "post_repair"
            if (slider.classList.contains("during_repair")) return "during_repair"
            if (slider.classList.contains("additional_estimation")) return "additional_estimation"
            return null
        }

        // Create export button
        const createExportButton = () => {
            const button = document.createElement("button")
            button.className = "export-pdf-btn px-4 py-2 bg-primary-color hover:bg-secondary-color text-white rounded-lg transition-all duration-200 flex items-center gap-2"
            button.innerHTML = `
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                </svg>
                ${localizedText.exportPdf}
            `
            return button
        }

        // Add export button to the slider
        const addExportButton = () => {
            const existingButton = slider.querySelector('.export-pdf-btn')
            if (existingButton) return

            const button = createExportButton()
            const buttonContainer = document.createElement("div")
            buttonContainer.className = "flex justify-end mb-4"
            buttonContainer.appendChild(button)

            // Insert button before the image container
            const imageContainer = slider.querySelector('.flex.gap-4')
            if (imageContainer) {
                slider.insertBefore(buttonContainer, imageContainer)
            } else {
                slider.appendChild(buttonContainer)
            }

            // Add click handler
            button.addEventListener('click', handleExportClick)
        }

        // Handle export button click
        const handleExportClick = async (e) => {
            e.preventDefault()
            const button = e.target.closest('.export-pdf-btn')
            const originalText = button.innerHTML

            try {
                // Show loading state
                button.disabled = true
                button.innerHTML = getLoadingState()

                // Get the claim ID from the URL or data attribute
                const claimId = getClaimId()
                if (!claimId)
                    throw new Error('Claim ID not found')

                const imageType = getImageType()
                if (!imageType)
                    throw new Error('Image type not found')

                const selectedIds = Array.from(slider.querySelectorAll(".image-select-checkbox:checked"))
                    .map(cb => cb.value)

                // Make AJAX request to export PDF
                const response = await fetchPdf(claimId, imageType, selectedIds)

                if (!response.ok)
                    throw new Error(`HTTP error! Status: ${response.status}`)

                const { file_url } = await response.json()
                window.open(file_url, '_blank')
            } catch (error) {
                console.error('Error exporting PDF:', error)
                showErrorMessage(localizedText.exportError)
            } finally {
                // Reset button state
                button.disabled = false
                button.innerHTML = originalText
            }
        }

        const fetchPdf = async (claimId, imageType, selectedIds) => {
            const response = await fetch(`/${namespace}/claims/${claimId}/export_pdf?image_type=${imageType}&selected_ids=${selectedIds.join(",")}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
                }
            })

            return response
        }

        // Get claim ID from various sources
        const getClaimId = () => {
            // Try to get from data-url attribute
            const dataUrl = slider?.dataset?.url
            if (dataUrl) {
                const urlMatch = dataUrl.match(new RegExp(`/${namespace}/claims/(\\d+)(?:/.*)?(?:\\?.*)?`))
                if (urlMatch) return urlMatch[1]
            }

            // Try to get from URL
            const urlMatch = window.location.pathname.match(/\/${namespace}\/claims\/(\d+)/)
            if (urlMatch) return urlMatch[1]

            return null
        }

        const getLoadingState = () => {
            return `
                <svg class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                ${localizedText.exporting}
            `;
        }

        const enableImageSelection = (slider) => {
            // Grab all thumbnails
            const thumbnails = slider.querySelectorAll(".thumbnail-container")

            thumbnails.forEach(container => {
                // Skip if checkbox already exists
                if (container.parentElement.classList.contains("thumbnail-wrapper")) return
            
                // Create wrapper around container + checkbox
                const wrapper = document.createElement("div")
                wrapper.className = "thumbnail-wrapper flex flex-col items-center"
            
                // Move the existing container inside wrapper
                container.parentNode.insertBefore(wrapper, container)
                wrapper.appendChild(container)

                // Create checkbox row
                const checkbox = document.createElement("input")
                checkbox.type = "checkbox"
                checkbox.className = "image-select-checkbox mt-2"
                checkbox.value = container.dataset.imageId

                // Append checkbox under thumbnail
                wrapper.appendChild(checkbox)
            })
        }

        // Show error message
        const showErrorMessage = (message) => {
            const existingError = slider.querySelector('.export-error-message')
            if (existingError) existingError.remove()

            const errorMessage = document.createElement('div')
            errorMessage.className = 'export-error-message bg-red-100 border border-red-400 text-red-700 px-4 py-2 mb-4 rounded'
            errorMessage.textContent = message

            slider.insertBefore(errorMessage, slider.firstChild)
        }

        // Monitor for when images are loaded and add export button
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    const imageContainer = slider.querySelector('.flex.gap-4')
                    if (imageContainer && !slider.querySelector('.export-pdf-btn')) {
                        addExportButton()
                        enableImageSelection(slider)
                    }
                }
            })
        })

        // Start observing the slider for changes
        observer.observe(slider, {
            childList: true,
            subtree: true
        })

        // Also check immediately in case images are already loaded
        setTimeout(() => {
            const imageContainer = slider.querySelector('.flex.gap-4')
            if (imageContainer && !slider.querySelector('.export-pdf-btn')) {
                addExportButton()
                enableImageSelection(slider)
            }
        }, 4000)
    })
})
